<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <div class="mb-4 d-flex align-items-center justify-content-between laporan-periode-wrapper">
                <div class="laporan-periode">
                    <h4>Daftar BPKB Macet</h4>
                    <h6>{{$helper.changeDateFormat(todayDate)}} 
                        (
                        <span>H + {{ periodeStart }} </span>
                        <span v-if="periodeEnd != ''"> s/d H + {{ periodeEnd }}</span>
                        )
                    </h6>
                </div>
                <b-button variant="pgiBtn" class="mb-0 download-btn" @click="openModalDownload()">
                    <i class="fa fa-download mr-2"></i>
                    Download Excel
                </b-button>
            </div>
            <b-row>
                <b-col md="4" sm="6" cols="12">
                    <div class="custom-card-dashboard balance-card">
                        <div class="d-flex align-items-center">
                            <div class="card-icon">
                                <i class="mb-2 fa fa-balance-scale"></i>
                            </div>
                            <div class="card-data ml-4">
                                <p class="mb-0 text-muted">Total BPKB Macet</p>
                                <strong class="mb-0">
                                    {{dataBpkbMacetAll.jumlah}}
                                </strong>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col md="4" sm="6" cols="12">
                    <div class="custom-card-dashboard balance-card">
                        <div class="d-flex align-items-center">
                            <div class="card-icon">
                                <i class="mb-2 fa fa-money"></i>
                            </div>
                            <div class="card-data ml-4">
                                <p class="mb-0 text-muted">Nominal BPKB Macet</p>
                                <strong class="mb-0">
                                    Rp. {{$helper.addThousandSeparator(dataBpkbMacetAll.pokokEfektif)}}
                                </strong>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-card >
                <template v-slot:header>
                    <h5>Daftar BPKB Macet Cabang</h5>
                </template>
                <div class="search-wrapper d-flex align-items-center justify-content-between">
                    <b-form-group
                        label="Filter"
                        label-for="filterInput"
                        class="form-inline form-group-wrapper mb-3"
                    >   
                        <div class="d-flex search-input-wrapper">
                            <multiselect
                                class="ml-2 mr-2"
                                name="filterCabang"
                                v-model="input.filterCabang" 
                                :options="cabangOption" 
                                :internal-search="true"
                                :allow-empty="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="-- Pilih filter cabang --"
                            />
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter()"> 
                                <i class="fa fa-search"></i>
                            </b-button>
                            <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset()">Reset</b-button>
                        </div>
                    </b-form-group>
                </div>
                <b-table bordered hover show-empty
                    :busy="isBusy"
                    :items="dataBpkbMacet" 
                    :fields="fields" 
                    :currentPage="currentPage" 
                    :perPage="perPage"
                    responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data BPKB macet.
                    </template>
                    <template v-slot:cell(jumlah)="row">
                        <div class="text-right no-wrap">
                            {{ row.item.jumlah }}                 
                        </div>
                    </template>
                    <template v-slot:cell(pokokEfektif)="row">
                        <div class="text-right no-wrap" v-if="row.item.pokokEfektif == null">{{$helper.addThousandSeparator(row.item.pokokEfektif)}} </div>
                        <div class="text-right no-wrap" v-else-if="row.item.pokokEfektif < 0">- Rp{{$helper.addThousandSeparator(row.item.pokokEfektif).replace("-", "")}}</div>
                        <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.pokokEfektif)}} </div>
                    </template>
                </b-table>

                <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                    <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                        <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled />
                            </template>
                        </b-form-select>
                        <span class="ml-2">{{ totalViewText }}</span>
                    </b-input-group>
                    <b-pagination class="mb-0"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        @input="onPageChange"
                    ></b-pagination>
                </div>
            </b-card>
        </div>
        <b-modal id="modal-download-excel" centered title="Download Excel" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoadLink == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'detail-daftar-bpkb-macet',
    data() {
        return {
            initStatus: 1,
            isBusy: true,
            input:{
                show: 10,
                filterCabang: null,
            },
            fields: [
                { key: "cabangName", label: "Cabang", sortable: true },
                { key: "jumlah", label: "Jumlah Macet", sortable: true },
                { key: "pokokEfektif", label: "Nominal Macet", sortable: true },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            dataBpkbMacetAll : [],
            dataBpkbMacet: [],
            filePath: "",
            cabangOption: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            id: '',
            todayDate: '',
            periodeStart: '',
            periodeEnd: '',
            isLoadLink: false,
            filePathDownload: ""
        }
    }, 
    methods: {
        
        init() {
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            
            this.id = this.$route.params.id

            let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                response.data.forEach((element) => {
                    if(element.id != this.srcCabangId)
                        this.cabangOption.push(element)
                })
            })

            let getDataBpkbMacet = this.$axios.get(`laporan-eksekutif/bpkb-macet/?${this.id}`).then(response => {
                this.dataBpkbMacetAll = response.data
                this.dataBpkbMacet = response.data.entries
                this.updateTotalItem()
              
            })

            Promise.all([getCabang, getDataBpkbMacet]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
             
                let indexAnd = this.id.indexOf("&")
                this.periodeStart = this.id.slice(6, indexAnd)
                if(this.id.includes("hSampai")){
                    let indexPeriodeStart = this.id.indexOf("hSampai=")
                    this.periodeEnd = this.id.slice(indexPeriodeStart+8)
                }
                var todayFormat = new Date();
                var dd = todayFormat.getDate();
                var mm = todayFormat.getMonth()+1; //January is 0!
                var yyyy = todayFormat.getFullYear();
                if(dd<10){
                        dd='0'+dd
                    } 
                    if(mm<10){
                        mm='0'+mm
                    } 

                todayFormat = yyyy+'-'+mm+'-'+dd;
                this.todayDate = todayFormat
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        //----------------- Fungsi Ambil Data Daftar Gadai -----------------

        getDataBpkbMacet(){
            this.dataBpkbMacet = this.dataBpkbMacetAll.entries
            this.toggleBusy()
            this.updateTotalItem()
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.perPage = this.input.show
            this.onPageChange()
        },

        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onReset(){
            this.filter = ""
            this.toggleBusy()
            this.getDataBpkbMacet()
        },
        
        onFilter(){
            
            if(this.input.filterCabang == null){
                this.$helper.toastErr(this, "Silakan isi nama cabang terlebih dahulu!")
            }else{
                let filteredArray = []

                for (var x of this.dataBpkbMacetAll.entries) {
                    if(x.cabangId == this.input.filterCabang.id){
                        filteredArray.push(x)
                    }
                }
                
                this.dataBpkbMacet = filteredArray
                this.onFiltered(this.dataBpkbMacet)
            }
        },

        onFiltered(filteredItems) {
            this.rows = filteredItems.length
            this.currentPage = 1
            this.perPage = this.input.show
            let prevLimit = null
            let limit = null
            
            prevLimit = (this.currentPage-1) * this.rows + 1
            limit = (this.currentPage-1) * this.rows + this.rows
            if (limit > this.input.show) limit = this.input.show
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(){
            this.rows = this.dataBpkbMacet.length
            if (this.perPage > this.rows) this.perPage = this.rows
            this.totalViewText = "Menampilkan 1 - " + this.perPage + " dari " + this.rows + " entri"
        },

        openModalDownload(){

            this.isLoadLink = true

            this.$axios.get(`laporan-eksekutif/bpkb-macet/dl/?${this.id}`).then(response => {
                
                this.$bvModal.show('modal-download-excel')
                this.filePathDownload = response.data
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isLoadLink = false
            })
        }
    },
    created() {
        this.init()
    }
}
</script>
